module.exports = __webpack_public_path__ + "static/img/invest-health5.8dd7ce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-health5.jpg
// module id = RZmI
// module chunks = 0